import React from 'react';
import axiosInstance from '../../Services/AxiosAPICaller';
import { ISite } from '../../Interfaces/ISites';
import './SiteNameLabel.css';

const SiteNameLabel: React.FC = () => {
  const [Site, setSite] = React.useState<ISite | null>(null);

  React.useEffect(() => {

    axiosInstance.get<{ data: Array<{ id: number, attributes: any }> }>(`/sites?fields[0]=id&fields[1]=Nom&fields[2]=Description&populate[Photo][fields][1]=url`)
      .then(response => {


        const item = response.data.data[0] || null;

        if (item && item.attributes) 
        {
            // Create Bubble Object From API returned Datas
            const ResponseSite: ISite = {
                Id: item.id,
                Nom: item.attributes.Nom,
                Image: item.attributes.Photo?.data?.attributes?.url || '',
                Description: item.attributes.Description,
                bulles: item.attributes.bulles ?? null,
                intervenants_externes: item.attributes.intervenants_externes ?? null
            };

            setSite(ResponseSite);
        } 
        
        else 
        {
          console.error('Invalid response structure:', response.data);
        }
      })
      .catch(error => {
        if (error.response) {
          console.error('Erreur lors de la récupération du site:', error.response.data);
        } else {
          console.error('Erreur lors de la récupération du site:', error.message);
        }
      });
  }, []); // Empty dependency array to run only once on mount

  if (!Site) return <p>Chargement...</p>;

  return (
    <div className='SiteTitleDiv'>
      <p className='SiteTitleTxt'>Site de {Site.Nom}</p>
      <img src={Site.Image} alt="page d'accueil" style={{ width: '100%' }} />
    </div>
  );
};

export default SiteNameLabel;